import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import TitleH4Component from "../../components/TitleH4Component";
import ParrafoComponent from "../../components/ParrafoComponent";
import InputComponent from "../../components/InputComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import SelectComponent from "../../components/SelectComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import LoaderComponent from "../../components/LoaderComponent";
import { Icon } from "@iconify/react/dist/iconify.js";
import stylebtn from "../../styles/btn.module.scss";
import styleform from "../../styles/form.module.scss";
import stylegeneral from "../../styles/general.module.scss";
import { BuscarCliente, PostCliente } from "../../api/ApiVenta";
import { PostPersona } from "../../api/Empleado";
import { getTransporte } from "../../api/transporte";
import { useAuth } from "../../context/AuthContext";
import { useFormatter } from "../../hooks/useFormatter";
import { crearAlquiler, postAbonoAlquiler } from "../../api/Alquiler";
import { abrirPdfAlquiler } from "../../api/Pdf";

const NuevoAlquilerPage = () => {
  const navigate = useNavigate();
  const { idUser } = useAuth();
  const { formatPrice, getNowDateTimeInput } = useFormatter();

  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [showModalImpresion, setShowModalImpresion] = useState(false);
  const [alquilerCreadoId, setAlquilerCreadoId] = useState(null);

  // ── Cliente (mismo flujo de captura rápida que venta rápida) ──
  const [control, setControl] = useState(false);
  const [currentPersona, setCurrentPersona] = useState({});
  const [currentCliente, setCurrentCliente] = useState([]);
  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  // ── Datos del alquiler ──
  const [formAlquiler, setFormAlquiler] = useState({
    fecha_hora_salida: getNowDateTimeInput(),
    fecha_hora_devolucion_esperada: "",
    observaciones: "",
    // Transporte, abono y descuento: mismos campos que venta rápida.
    transporte: 0,
    nombre_conductor: "",
    celular_conductor: "",
    descuento: 0,
    total_pagado: 0,
    fecha_vencimiento: "",
    descripcionPago: "",
    // Quien recibe el material puede ser distinto del cliente/titular del
    // alquiler (igual que venta rápida).
    quien_recibe: "",
    direccion_recibe: "",
  });

  // ── Productos (100% manual: nombre y precio digitados, igual que venta
  // rápida; no está ligado al inventario) ──
  const [producto, setProducto] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [precioDiario, setPrecioDiario] = useState("");
  const [carrito, setCarrito] = useState([]);

  // ── Transporte, abono y descuento (mismas condiciones que venta rápida:
  // ver VentasRapidasPages.jsx) ──
  const [checkboxes, setCheckboxes] = useState({
    isCheckedTransporte: false,
    isCheckedAbono: false,
    isCheckedDescuento: false,
    isCheckedDescripcion: false,
  });
  const [dataTransporte, setDataTransporte] = useState([]);
  const [transporteID, setTransporteID] = useState(null);
  const [descripcionAbono, setDescripcionAbono] = useState("");
  const [fechaAbono, setFechaAbono] = useState("");
  const [horaAbono, setHoraAbono] = useState("");

  useEffect(() => {
    const fetchTransporte = async () => {
      try {
        const res = await getTransporte({});
        setDataTransporte(res?.data || []);
      } catch (error) {
        console.error("Error al obtener los transportes:", error);
      }
    };
    fetchTransporte();
  }, []);

  const obtenerDatosTransporte = (idSeleccionado) => {
    const encontrado = dataTransporte.find((item) => item.id === idSeleccionado);
    if (!encontrado) return null;
    return {
      nombre: encontrado.Persona?.nombre,
      apellido: encontrado.Persona?.apellido,
      celular: encontrado.Persona?.celular,
    };
  };

  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({ ...formDataPersona, [name]: value });
  };

  const handleInputChangeAlquiler = (event) => {
    const { name, value } = event.target;
    setFormAlquiler({ ...formAlquiler, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prev) => ({ ...prev, [id]: checked }));

    if (id === "isCheckedTransporte" && !checked) {
      setFormAlquiler((prev) => ({
        ...prev,
        transporte: 0,
        nombre_conductor: "",
        celular_conductor: "",
      }));
      setTransporteID(null);
    }

    if (id === "isCheckedAbono" && !checked) {
      setFormAlquiler((prev) => ({ ...prev, total_pagado: 0, fecha_vencimiento: "" }));
      setDescripcionAbono("");
      setFechaAbono("");
      setHoraAbono("");
    }

    if (id === "isCheckedDescuento" && !checked) {
      setFormAlquiler((prev) => ({ ...prev, descuento: 0 }));
    }

    if (id === "isCheckedDescripcion" && !checked) {
      setFormAlquiler((prev) => ({ ...prev, descripcionPago: "" }));
    }
  };

  const mostrarMensaje = (texto) => {
    setMensaje(texto);
    setTimeout(() => setMensaje(""), 4000);
  };

  const verificarCliente = async (e) => {
    e.preventDefault();
    const cedula = formDataPersona.cedula?.trim();
    if (!cedula) {
      mostrarMensaje("Por favor ingrese una cédula válida");
      return;
    }

    try {
      setLoading(true);
      const res = await BuscarCliente(cedula);
      setControl(res?.success);

      if (res?.success && res.data) {
        const cliente = res.data;
        setFormDataPersona((prev) => ({
          ...prev,
          cedula: cliente.cedula || cedula,
          nombre: cliente.nombre || "",
          apellido: cliente.apellido || "",
          direccion: cliente.direccion || "",
          celular: cliente.celular || "",
        }));
        setCurrentPersona(cliente);
        setCurrentCliente(cliente.Clientes || []);
        mostrarMensaje("Cliente encontrado");
      } else {
        setCurrentPersona({});
        setCurrentCliente([]);
        mostrarMensaje("Cliente no encontrado, complete los datos para registrarlo");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Resuelve (o crea) el id de Cliente a partir de los datos capturados.
  // Mismo flujo que usa venta rápida para no duplicar lógica de negocio.
  const crearCliente = async () => {
    if (!control) {
      const resP = await PostPersona(formDataPersona);
      if (resP.success) {
        const rescliente = await PostCliente(resP.data.idP);
        return rescliente?.data?.id;
      }
      const existing = await BuscarCliente(formDataPersona.cedula);
      if (existing?.success && existing.data) {
        const existingId = existing.data.Clientes?.[0]?.id;
        if (existingId) return existingId;
        const rescliente = await PostCliente(existing.data.idP);
        return rescliente?.data?.id;
      }
      throw new Error("No fue posible registrar el cliente");
    }

    if (currentCliente.length === 0) {
      const rescliente = await PostCliente(currentPersona?.idP);
      return rescliente?.data?.id;
    }

    return currentCliente[0]?.id;
  };

  const agregarProducto = () => {
    const nombreProducto = producto.trim();
    const cant = Number(cantidad);
    const precio = Number(precioDiario);

    if (!nombreProducto) {
      mostrarMensaje("Ingrese el nombre del producto");
      return;
    }
    if (!cant || cant <= 0) {
      mostrarMensaje("Ingrese una cantidad válida");
      return;
    }
    if (!precio || precio <= 0) {
      mostrarMensaje("Ingrese un precio por día válido");
      return;
    }

    setCarrito((prev) => {
      const existente = prev.find((item) => item.producto === nombreProducto);
      if (existente) {
        return prev.map((item) =>
          item.producto === nombreProducto
            ? { ...item, cantidad: item.cantidad + cant }
            : item,
        );
      }
      return [...prev, { producto: nombreProducto, cantidad: cant, precioDiario: precio }];
    });

    setProducto("");
    setCantidad("");
    setPrecioDiario("");
  };

  const quitarProducto = (nombreProducto) => {
    setCarrito((prev) => prev.filter((item) => item.producto !== nombreProducto));
  };

  const totalProvisionalPorDia = carrito.reduce(
    (acc, item) => acc + item.cantidad * item.precioDiario,
    0,
  );

  const registrarAlquiler = async () => {
    if (
      !formDataPersona.nombre ||
      !formDataPersona.apellido ||
      !formDataPersona.cedula
    ) {
      mostrarMensaje("El nombre, apellido y cédula del cliente son obligatorios");
      return;
    }
    if (carrito.length === 0) {
      mostrarMensaje("Debe agregar al menos un producto al alquiler");
      return;
    }
    if (!formAlquiler.fecha_hora_salida) {
      mostrarMensaje("La fecha y hora de salida es obligatoria");
      return;
    }
    // Mismas condiciones que venta rápida (ver VentasRapidasPages.jsx ->
    // crearVentaRapida): si hay abono, la fecha de pago pendiente es
    // obligatoria; y siempre debe quedar registrada una descripción de
    // pago, ya sea junto al abono o mediante el checkbox independiente.
    if (checkboxes.isCheckedAbono && !formAlquiler.fecha_vencimiento) {
      mostrarMensaje("Fecha de pago es obligatoria");
      return;
    }
    const tieneDescripcionAbono = checkboxes.isCheckedAbono && descripcionAbono?.trim();
    if (
      !tieneDescripcionAbono &&
      (!checkboxes.isCheckedDescripcion || !formAlquiler.descripcionPago?.trim())
    ) {
      mostrarMensaje(
        "Antes de registrar el alquiler es obligatorio activar y agregar la descripción de pago",
      );
      return;
    }

    try {
      setLoading(true);
      const idCliente = await crearCliente();

      const { status, res } = await crearAlquiler({
        id_user: idUser,
        id_cliente: idCliente,
        nombre: `${formDataPersona.nombre} ${formDataPersona.apellido}`.trim(),
        cedula: formDataPersona.cedula,
        telefono: formDataPersona.celular,
        fecha_hora_salida: formAlquiler.fecha_hora_salida,
        fecha_hora_devolucion_esperada:
          formAlquiler.fecha_hora_devolucion_esperada || null,
        observaciones: formAlquiler.observaciones,
        detalles: carrito.map((item) => ({
          producto: item.producto,
          cantidad: item.cantidad,
          precioDiario: item.precioDiario,
        })),
        transporte: checkboxes.isCheckedTransporte ? formAlquiler.transporte : 0,
        nombre_conductor: checkboxes.isCheckedTransporte ? formAlquiler.nombre_conductor : null,
        celular_conductor: checkboxes.isCheckedTransporte ? formAlquiler.celular_conductor : null,
        descuento: checkboxes.isCheckedDescuento ? formAlquiler.descuento : 0,
        total_pagado: checkboxes.isCheckedAbono ? formAlquiler.total_pagado : 0,
        descripcionPago: checkboxes.isCheckedDescripcion ? formAlquiler.descripcionPago : null,
        quien_recibe: formAlquiler.quien_recibe || null,
        direccion_recibe: formAlquiler.direccion_recibe || null,
      });

      if (status === 201 && res?.success) {
        // El abono inicial ya quedó guardado en Alquiler.total_pagado; este
        // segundo registro es solo el historial/auditoría del abono, igual
        // que en venta rápida (ver postAbonoVR en VentasRapidasPages.jsx).
        if (checkboxes.isCheckedAbono && Number(formAlquiler.total_pagado) > 0) {
          await postAbonoAlquiler(
            res.data.id,
            formAlquiler.total_pagado,
            "Abono inicial " + descripcionAbono,
            idUser,
            fechaAbono || null,
            horaAbono || null,
          );
        }

        setAlquilerCreadoId(res.data.id);
        setShowModalImpresion(true);
      } else {
        mostrarMensaje(res?.msg || "No fue posible registrar el alquiler");
      }
    } catch (error) {
      mostrarMensaje(error.message || "No fue posible registrar el alquiler");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          NUEVO ALQUILER
        </TitleH2Component>
      </HeaderComponent>

      <div className="conatiner-global pt-3 mb-5">
        {loading ? (
          <LoaderComponent styleGroup="mt-5" />
        ) : (
          <>
            <section className="container border border-dark rounded p-3 mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                INFORMACIÓN DEL CLIENTE
              </TitleH4Component>
              <div className="row gy-3">
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Documento*"
                    placeholder="Cédula"
                    styleLabel="fw600 WorkSans"
                    htmlFor="cedula"
                    type="text"
                    name="cedula"
                    value={formDataPersona.cedula}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-2 d-flex align-items-end">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.primary}`}
                    onClick={verificarCliente}
                  >
                    Verificar
                  </button>
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Nombre*"
                    placeholder="Nombre"
                    styleLabel="fw600 WorkSans"
                    htmlFor="nombre"
                    type="text"
                    name="nombre"
                    value={formDataPersona.nombre}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Apellido*"
                    placeholder="Apellido"
                    styleLabel="fw600 WorkSans"
                    htmlFor="apellido"
                    type="text"
                    name="apellido"
                    value={formDataPersona.apellido}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Dirección"
                    placeholder="Dirección"
                    styleLabel="fw600 WorkSans"
                    htmlFor="direccion"
                    type="text"
                    name="direccion"
                    value={formDataPersona.direccion}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Celular"
                    placeholder="Celular"
                    styleLabel="fw600 WorkSans"
                    htmlFor="celular"
                    type="text"
                    name="celular"
                    value={formDataPersona.celular}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Quien recibe"
                    placeholder="Nombre de quien recibe"
                    styleLabel="fw600 WorkSans"
                    htmlFor="quien_recibe"
                    type="text"
                    name="quien_recibe"
                    value={formAlquiler.quien_recibe}
                    onChange={handleInputChangeAlquiler}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Dirección de quien recibe"
                    placeholder="Dirección de entrega"
                    styleLabel="fw600 WorkSans"
                    htmlFor="direccion_recibe"
                    type="text"
                    name="direccion_recibe"
                    value={formAlquiler.direccion_recibe}
                    onChange={handleInputChangeAlquiler}
                  />
                </div>
              </div>
            </section>

            <section className="container border border-dark rounded p-3 mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                FECHAS DEL ALQUILER
              </TitleH4Component>
              <div className="row gy-3">
                <div className="col-12 col-md-6 col-xl-4">
                  <InputComponent
                    label="Fecha y hora de salida*"
                    styleLabel="fw600 WorkSans"
                    htmlFor="fecha_hora_salida"
                    type="datetime-local"
                    name="fecha_hora_salida"
                    value={formAlquiler.fecha_hora_salida}
                    onChange={handleInputChangeAlquiler}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                  <InputComponent
                    label="Fecha y hora de devolución esperada"
                    styleLabel="fw600 WorkSans"
                    htmlFor="fecha_hora_devolucion_esperada"
                    type="datetime-local"
                    name="fecha_hora_devolucion_esperada"
                    value={formAlquiler.fecha_hora_devolucion_esperada}
                    onChange={handleInputChangeAlquiler}
                  />
                </div>
                <div className="col-12 col-xl-4">
                  <InputComponent
                    label="Observaciones"
                    placeholder="Observaciones (opcional)"
                    styleLabel="fw600 WorkSans"
                    htmlFor="observaciones"
                    type="text"
                    name="observaciones"
                    value={formAlquiler.observaciones}
                    onChange={handleInputChangeAlquiler}
                  />
                </div>
              </div>
            </section>

            <section className="container border border-dark rounded p-3 mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                PRODUCTOS A ALQUILAR
              </TitleH4Component>
              <div className="row gy-3 align-items-end">
                <div className="col-12 col-sm-6 col-lg-3">
                  <InputComponent
                    label="Producto"
                    placeholder="Ingrese producto"
                    styleLabel="fw600 WorkSans"
                    htmlFor="producto"
                    type="text"
                    name="producto"
                    value={producto}
                    onChange={(e) => setProducto(e.target.value)}
                  />
                </div>
                <div className="col-6 col-sm-6 col-lg-3">
                  <InputComponent
                    label="Cantidad"
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    htmlFor="cantidad"
                    type="number"
                    name="cantidad"
                    value={cantidad}
                    onChange={(e) => setCantidad(e.target.value)}
                  />
                </div>
                <div className="col-6 col-sm-6 col-lg-3">
                  <MoneyInputComponent
                    label="Precio/día"
                    styleLabel="fw600 WorkSans"
                    htmlFor="precioDiario"
                    name="precioDiario"
                    value={precioDiario}
                    onChange={(e) => setPrecioDiario(e.target.value)}
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.primary}`}
                    onClick={agregarProducto}
                  >
                    Agregar
                  </button>
                </div>
              </div>

              <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mt-3 mb-0">
                {mensaje}
              </ParrafoComponent>

              <div className="table-responsive mt-4">
                <table className="table table-bordered tableGeneral">
                  <thead>
                    <tr>
                      <th className="color-madera">Producto</th>
                      <th className="color-madera text-center">Cantidad</th>
                      <th className="color-madera text-end">Precio/día</th>
                      <th className="color-madera text-end">Subtotal/día</th>
                      <th className="color-madera text-center">Quitar</th>
                    </tr>
                  </thead>
                  {carrito.length > 0 ? (
                    <tbody>
                      {carrito.map((item) => (
                        <tr key={item.producto}>
                          <td>{item.producto}</td>
                          <td className="text-center">{item.cantidad}</td>
                          <td className="text-end">
                            {formatPrice(item.precioDiario)}
                          </td>
                          <td className="text-end">
                            {formatPrice(item.cantidad * item.precioDiario)}
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex color-danger`}
                              onClick={() => quitarProducto(item.producto)}
                            >
                              <Icon icon="majesticons:delete-bin" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={5} className="text-center">
                          SIN PRODUCTOS AGREGADOS
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>

              <div className="d-flex justify-content-end">
                <ParrafoComponent styleGroup="box-text fw700 roboto">
                  Total provisional por día:{" "}
                  <span className="color-soccess">
                    {formatPrice(totalProvisionalPorDia)}
                  </span>
                </ParrafoComponent>
              </div>
              <ParrafoComponent styleGroup="text-end color-gris fw400 WorkSans">
                El total final se calcula al momento de cada devolución, según
                los días reales de alquiler.
              </ParrafoComponent>
            </section>

            <section className="container border border-dark rounded p-3 mb-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                TRANSPORTE, ABONO Y DESCUENTO
              </TitleH4Component>

              <div className={`${styleform.checkbox} d-flex justify-content-start mb-2`}>
                <input
                  className="me-2"
                  type="checkbox"
                  id="isCheckedTransporte"
                  checked={checkboxes.isCheckedTransporte}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="isCheckedTransporte">
                  Transporte
                </label>
              </div>
              {checkboxes.isCheckedTransporte && (
                <div className="row gy-3 mb-2">
                  <div className="col-12 col-md-6">
                    <MoneyInputComponent
                      label="Valor transporte"
                      styleLabel="fw600 WorkSans"
                      htmlFor="transporte"
                      name="transporte"
                      value={formAlquiler.transporte}
                      onChange={handleInputChangeAlquiler}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <SelectComponent
                      label="Transporte"
                      styleGroup={`${stylegeneral.wselect}`}
                      styleLabel="fw600 WorkSans color-madera mb-1"
                      options={dataTransporte.map((t) => ({
                        value: t.id,
                        label: `${t?.Persona?.nombre || ""} ${t?.Persona?.apellido || ""}`.trim(),
                      }))}
                      capOpcions={(v) => {
                        setTransporteID(v);
                        const datos = obtenerDatosTransporte(v);
                        if (datos) {
                          setFormAlquiler((prev) => ({
                            ...prev,
                            nombre_conductor: `${datos.nombre} ${datos.apellido}`.trim(),
                            celular_conductor: datos.celular,
                          }));
                        }
                      }}
                      customPlaceholder="Seleccionar"
                      name="transporteConductor"
                      value={dataTransporte.find((o) => o.id === transporteID) ? {
                        value: transporteID,
                        label: (() => {
                          const t = dataTransporte.find((o) => o.id === transporteID);
                          return `${t?.Persona?.nombre || ""} ${t?.Persona?.apellido || ""}`.trim();
                        })(),
                      } : null}
                      isClearable
                    />
                    {formAlquiler.nombre_conductor && (
                      <ParrafoComponent styleGroup="color-madera fw400 WorkSans mt-2 mb-0">
                        Conductor: {formAlquiler.nombre_conductor}
                        {formAlquiler.celular_conductor
                          ? ` - ${formAlquiler.celular_conductor}`
                          : ""}
                      </ParrafoComponent>
                    )}
                  </div>
                </div>
              )}

              <div className={`${styleform.checkbox} d-flex justify-content-start mb-2`}>
                <input
                  className="me-2"
                  type="checkbox"
                  id="isCheckedAbono"
                  checked={checkboxes.isCheckedAbono}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="isCheckedAbono">
                  Abono
                </label>
              </div>
              {checkboxes.isCheckedAbono && (
                <div className="row gy-3 mb-2">
                  <div className="col-12 col-md-6 col-xl-3">
                    <MoneyInputComponent
                      label="Valor del abono"
                      styleLabel="fw600 WorkSans"
                      htmlFor="total_pagado"
                      name="total_pagado"
                      value={formAlquiler.total_pagado}
                      onChange={handleInputChangeAlquiler}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Fecha pendiente de pago*"
                      styleLabel="fw600 WorkSans"
                      htmlFor="fecha_vencimiento"
                      type="date"
                      name="fecha_vencimiento"
                      value={formAlquiler.fecha_vencimiento}
                      onChange={handleInputChangeAlquiler}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Fecha del abono"
                      styleLabel="fw600 WorkSans"
                      htmlFor="fecha_abono"
                      type="date"
                      name="fecha_abono"
                      value={fechaAbono}
                      onChange={(e) => setFechaAbono(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Hora del abono"
                      styleLabel="fw600 WorkSans"
                      htmlFor="hora_abono"
                      type="time"
                      name="hora_abono"
                      value={horaAbono}
                      onChange={(e) => setHoraAbono(e.target.value)}
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      name="descripcionAbono"
                      placeholder="Descripción del abono"
                      className="form-control"
                      rows={3}
                      value={descripcionAbono}
                      onChange={(e) => setDescripcionAbono(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              )}

              <div className={`${styleform.checkbox} d-flex justify-content-start mb-2`}>
                <input
                  className="me-2"
                  type="checkbox"
                  id="isCheckedDescuento"
                  checked={checkboxes.isCheckedDescuento}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="isCheckedDescuento">
                  Descuento
                </label>
              </div>
              {checkboxes.isCheckedDescuento && (
                <div className="row gy-3 mb-2">
                  <div className="col-12 col-md-6 col-xl-3">
                    <MoneyInputComponent
                      label="Valor del descuento"
                      styleLabel="fw600 WorkSans"
                      htmlFor="descuento"
                      name="descuento"
                      value={formAlquiler.descuento}
                      onChange={handleInputChangeAlquiler}
                    />
                  </div>
                </div>
              )}

              <div className={`${styleform.checkbox} d-flex justify-content-start mb-2`}>
                <input
                  className="me-2"
                  type="checkbox"
                  id="isCheckedDescripcion"
                  checked={checkboxes.isCheckedDescripcion}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="isCheckedDescripcion">
                  Descripción de pago
                </label>
              </div>
              {checkboxes.isCheckedDescripcion && (
                <textarea
                  name="descripcionPago"
                  placeholder="Descripción de pago"
                  className="form-control"
                  rows={3}
                  value={formAlquiler.descripcionPago}
                  onChange={handleInputChangeAlquiler}
                ></textarea>
              )}

              <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mt-3 mb-0">
                {mensaje}
              </ParrafoComponent>
            </section>

            <div className="container d-flex justify-content-end">
              <button
                type="button"
                className={`${stylebtn.btn} ${stylebtn.primary}`}
                onClick={registrarAlquiler}
              >
                REGISTRAR ALQUILER
              </button>
            </div>
          </>
        )}
      </div>

      <ModalGeneralComponent
        ModalHeader={false}
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showModalImpresion}
        handleClose={() => navigate(`/alquileres/${alquilerCreadoId}`)}
      >
        <div className="text-center">
          <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-4 text-center WorkSans">
            ¡Alquiler registrado con éxito!
          </TitleH2Component>
          <div className="d-flex justify-content-center flex-wrap gap-3">
            <button
              type="button"
              className={`${stylebtn.btn} ${stylebtn.primary}`}
              onClick={() => abrirPdfAlquiler(alquilerCreadoId)}
            >
              Imprimir factura
            </button>
            <button
              type="button"
              className={`${stylebtn.btn} ${stylebtn.secundary}`}
              onClick={() => navigate(`/alquileres/${alquilerCreadoId}`)}
            >
              Ver alquiler
            </button>
          </div>
        </div>
      </ModalGeneralComponent>
    </Fragment>
  );
};

export default NuevoAlquilerPage;
